<template>
  <div class="box1">
    <div class="content">
      <div class="icon">紧跟行业发展趋势 课程全新升级V11.1</div>
      <div class="title">新媒体+短视频直播运营</div>
      <div class="intro">
        聚焦培养行业热门岗位（短视频/直播/社群运营）<br />
        精准发力，靶向施策，就业率远超其他竞品<br />
        百万粉丝大V参与课研
      </div>
    </div>
    <vue-seamless-scroll
      :data="list"
      :class-option="classOption1"
      class="seamless-warp"
    >
      <div class="demo">
        <div class="item" v-for="(item, index) in list" :key="index">
          <p>{{ item.p1 }}</p>
          <p>{{ item.p2 }}</p>
        </div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      list: [
        {
          p1: "账号定位能力",
          p2: "解决企业账号商业定位问题",
        },
        { p1: "内容运营能力", p2: "解决新媒体账号内容输出问题" },
        { p1: "用户运营能力", p2: "解决用户的增量、互动、转化等问题" },
        { p1: "数据运营能力", p2: "具备数据驱动运营能力" },
        {
          p1: "渠道运营能力",
          p2: "能够通过渠道布局完成账号矩阵运营",
        },
      ],
    };
  },
  computed: {
    classOption1() {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;

  width: 100%;
  height: 600px;
  background: #fefbf3 url("../../../assets/coursePage/newMedia/box1/bgc.png")
    no-repeat;
  background-size: cover;
  background-position: center;
  height: 852px;
  box-sizing: border-box;

  .content {
    padding: 80px 0 0 41px;
    box-sizing: border-box;

    .icon {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #663329;
      line-height: 26px;
    }
    .title {
      font-size: 60px;
      font-family: PingFang;
      font-weight: 800;
      color: #1a0400;
      line-height: 60px;
      margin: 40px 0 25px;
    }
    .intro {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #663329;
      line-height: 54px;
    }
  }
  .seamless-warp {
    margin-top: 155px;
    width: 100%;
    overflow: hidden;
    div:nth-child(1) {
    }
    .demo {
      display: flex;
    }
    .item {
      flex-shrink: 0;

      height: 155px;
      border: 1px solid #ffffff;
      background: linear-gradient(-9deg, #ffe7da 0%, #fffaf7 100%);
      border-radius: 10px;
      margin-right: 20px;
      overflow: hidden;
      text-align: left;
      padding-left: 30px;
      box-sizing: border-box;
      p:nth-child(1) {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #991900;
        margin-top: 39px;
        line-height: 28px;
      }
      p:nth-child(2) {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #665552;
        margin-top: 26px;
        line-height: 24px;
      }
    }
    .item:nth-child(1) {
      width: 349px;
    }
    .item:nth-child(2) {
      width: 373px;
    }
    .item:nth-child(3) {
      width: 445px;
    }
    .item:nth-child(4) {
      width: 301px;
    }
    .item:nth-child(5) {
      width: 445px;
    }
  }
}
</style>
